import { render, staticRenderFns } from "./EventHeader.vue?vue&type=template&id=e0feb640&scoped=true&"
import script from "./EventHeader.vue?vue&type=script&lang=js&"
export * from "./EventHeader.vue?vue&type=script&lang=js&"
import style0 from "./EventHeader.vue?vue&type=style&index=0&id=e0feb640&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0feb640",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
